import React from 'react';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const EmpanelmentContent = () => {

  return (
    <section className="empanelment-section p_relative">
            <div className="auto-container">
                <div className="row clearfix">
                    {/* <Collapse defaultActiveKey={['1']} onChange={() => {}}>
                        <Panel header="Empanelment" key="1">
                            <p>
                            <ul>
                                <li>NTR Arogya Vaidya Seva (Arogyasri)</li>
                                <li>EHS</li>
                                <li>ESI</li>
                                <li>Arogya Raksha</li>
                                <li>All Health Insurances</li>
                                <li>DBCS Services</li>
                            </ul>
                            </p>
                        </Panel>
                        
                    </Collapse> */}

                    <div className="col-lg-12 col-md-12 col-sm-12 content-column">
                        <div className="content_block_nine">
                            <div className="content-box mr_30 p_relative">
                                <div className="sec-title-two mb_50">
                                    {/* <h5 className="mb_25">Faq's</h5> */}
                                    {/* <h2 className="d_block fs_40 fw_bold">Facilities and Services</h2> */}
                                </div>
                                <div className="accordion-inner">
                                    <ul className="accordion-box">
                                        <li className="accordion block active-block">
                                            <div className="acc-btn active">
                                                <div className="icon-outer"><i className="far fa-angle-down"></i></div>
                                                <h5>Empanelment</h5>
                                            </div>
                                            <div className="acc-content current">
                                                <div className="text">
                                                <p>
                                                    <ul className="list-style-one clearfix">
                                                        <li>NTR Arogya Vaidya Seva (Arogyasri)</li>
                                                        <li>EHS</li>
                                                        <li>ESI</li>
                                                        <li>Arogya Raksha</li>
                                                        <li>All Health Insurances</li>
                                                        <li>DBCS Services</li>
                                                    </ul>
                                                </p>
                                                </div>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
  }
  
  export default EmpanelmentContent;